import { render, staticRenderFns } from "./FaqActionButtons.vue?vue&type=template&id=bb345e3e&"
import script from "./FaqActionButtons.vue?vue&type=script&lang=js&"
export * from "./FaqActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./FaqActionButtons.vue?vue&type=style&index=0&id=bb345e3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports